import { ChevronDown, Check } from "lucide-react";
import { WHEELS_SEO as S } from "../../data/wheelsSeo";

const box = "rounded-[18px] border-[3px] p-3 sm:p-4";
const h2 = "ua-title text-2xl leading-none sm:text-3xl";

export function WheelsSeoSection() {
  return (
    <section className="mt-8 grid gap-2 sm:gap-3 md:grid-cols-2" data-testid="wheels-seo-section">
      <div className={`${box} border-[#FFC15E] bg-[#2A0F45] text-white md:col-span-2`} data-testid="wheels-seo-how">
        <h2 className={h2}>How the wheel works</h2>
        <p className="mt-1 text-sm font-semibold text-white/90">{S.intro}</p>
        <ol className="mt-3 grid gap-2 sm:grid-cols-3">
          {S.steps.map((s, i) => (
            <li key={s.title} className="rounded-xl border-2 border-[#FFC15E] bg-white/10 p-2.5" data-testid={`wheels-seo-step-${i + 1}`}>
              <span className="flex items-center gap-2 font-comic text-base text-[#FFE14D]"><span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#FF5D1F] text-xs text-white">{i + 1}</span>{s.title}</span>
              <p className="mt-1 text-xs font-semibold text-white/85">{s.text}</p>
            </li>
          ))}
        </ol>
      </div>
      <div className={`${box} border-[#FFB36B] bg-white text-[#3b1800]`} data-testid="wheels-seo-uses">
        <h2 className={`${h2} text-[#FF5D1F]`}>What can you use it for?</h2>
        <div className="mt-2 grid grid-cols-2 gap-1.5">
          {S.uses.map((u) => (
            <div key={u.title} className="rounded-xl border-2 border-[#FFD9A8] bg-[#FFF6E6] p-2">
              <h3 className="font-comic text-sm">{u.title}</h3>
              <p className="text-xs text-[#6b3a12]">{u.text}</p>
            </div>
          ))}
        </div>
      </div>
      <div className={`${box} border-[#9FE59F] bg-[#CFF5CF] text-[#3b1800]`} data-testid="wheels-seo-why">
        <h2 className={h2}>Why DITHER's wheel?</h2>
        <ul className="mt-2 space-y-1.5">
          {S.why.map((w) => <li key={w} className="flex items-start gap-2 text-sm font-semibold"><Check className="mt-0.5 h-4 w-4 shrink-0 text-[#0E7A3E]" strokeWidth={3} />{w}</li>)}
        </ul>
      </div>
      <div className={`${box} border-[#FFC15E] bg-white text-[#3b1800] md:col-span-2`} data-testid="wheels-seo-faq">
        <h2 className={`${h2} text-[#FF5D1F]`}>Spin the wheel FAQ</h2>
        <div className="mt-2 grid items-start gap-1.5 md:grid-cols-2">
          {S.faqs.map((f, i) => (
            <details key={f.q} className="group rounded-xl border-2 border-[#FFD9A8] bg-[#FFF6E6] px-3 py-2" data-testid={`wheels-faq-item-${i}`}>
              <summary className="flex cursor-pointer list-none items-center justify-between gap-2 font-comic text-sm">
                <h3>{f.q}</h3><ChevronDown className="h-4 w-4 shrink-0 transition-transform group-open:rotate-180" strokeWidth={3} />
              </summary>
              <p className="mt-1 text-sm text-[#6b3a12]">{f.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
